<template>
  <div class="modal-bg" @click.self="$emit('close')">
    <div class="character-modal">
      <button class="close-btn" @click="$emit('close')" aria-label="بستن">
        <i class="fa fa-times"></i>
      </button>
      <h4 class="modal-title">انتخاب شخصیت</h4>
      
      <!-- Search Box -->
      <div class="search-section">
        <div class="search-input-wrapper">
          <i class="fa-solid fa-search search-icon"></i>
          <input 
            v-model="searchQuery"
            type="text" 
            placeholder="جستجو در شخصیت ها..."
            class="search-input"
            @input="filterCharacters"
          />
          <button v-if="searchQuery" @click="clearSearch" class="clear-search-btn">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
      </div>
      
      <!-- Character Categories -->
      <div class="scrollable-component">
        <button 
          v-for="category in characterCategories" 
          :key="category.id" 
          class="category-button"
          :class="{ active: selectedCategory === category.id }"
          @click="scrollToCategory(category.id)"
        >
          {{ category.name }}
        </button>
      </div>

      <!-- Character Groups -->
      <div v-for="category in displayCategories" :key="category.id" :id="'category-' + category.id" class="category-group">
        <div class="category-title">
          {{ category.name }}
          <span class="character-count">({{ category.characters.length }})</span>
        </div>
        <div class="character-list">
          <div
            v-for="character in category.characters"
            :key="character.id"
            class="character-card"
            @click="$emit('select', character)"
          >
            <div class="character-image" :style="{ backgroundImage: 'url(' + character.image + ')' }"></div>
            <div class="character-info">
              <span class="character-name">{{ character.name }}</span>
              <div class="chat-button">گفتگو</div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- No Results Message -->
      <div v-if="searchQuery && filteredCategories.length === 0" class="no-results">
        <i class="fa-solid fa-search"></i>
        <p>هیچ شخصیتی یافت نشد</p>
        <button @click="clearSearch" class="clear-search-link">پاک کردن جستجو</button>
      </div>

      <!-- Suggestion Box Section -->
      <div class="suggestion-section">
        <div class="suggestion-title">
          <i class="fa-solid fa-comment" aria-hidden="true"></i>
          <span>شخصیت های پیشنهادی شما</span>
        </div>
        <div class="suggestion-textarea">
          <textarea 
            v-model="chatbox"
            placeholder="📝 توضیحی در رابطه با شخصیت ای که مد نظرتان هست را با ما به اشتراک بگذارید"
            class="suggestion-input"
          ></textarea>
        </div>
        <div @click="sendSuggestion()" class="suggestion-button">
          <span>ارسال</span>
          <i class="fa-solid fa-paper-plane"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { notify } from "@kyvg/vue3-notification";

export default {
  name: "CharacterSelectModal",
  data() {
    return {
      selectedCategory: null,
      chatbox: '',
      searchQuery: '',
      filteredCategories: [],
      characterCategories: [
        {
          id: 'shakhsiat',
          name: 'رشد شخصیتی و حرفه ای',
          characters: [
            { name: 'همه کاره', image: require('@/assets/img/roboexpression/Flying.png'), id: 'chat', title: "روبو" },
            { name: 'تراپیست', image: require('@/assets/img/characters/therapist.jpg'), id: 'moshaver', title: "تراپیست" },
            { name: 'مشاور دوستیابی', image: require('@/assets/img/characters/datingadvisor.jpg'), id: 'dostyabi', title: "مشاور دوستیابی" },
            { name: 'دکتر', image: require('@/assets/img/characters/doctor.jpg'), id: 'doctor', title: "دکتر" },
            { name: 'وکیل', image: require('@/assets/img/characters/lawyer.jpg'), id: 'vakil', title: "وکیل" },
            { name: 'مربی شخصی', image: require('@/assets/img/characters/personaltrainer.jpg'), id: 'morabishakhsi', title: "مربی شخصی" },
            { name: 'مشاور حرفه ای کاری', image: require('@/assets/img/characters/jobconsultant.jpg'), id: 'moshaverekari', title: "مشاور حرفه ای کاری" },
            { name: 'مکانیک', image: require('@/assets/img/characters/mechanic.jpg'), id: 'mechanic', title: "مکانیک" },
            { name: 'معلم خصوصی', image: require('@/assets/img/characters/teacher.jpg'), id: 'teacher', title: "معلم خصوصی" },
          ]
        },
        {
          id: 'fanavari',
          name: 'فناوری و دنیای دیجیتال',
          characters: [
            { name: 'طراح گرافیک', image: require('@/assets/img/characters/graphicdesigner.jpg'), id: 'tarahgraphic', title: "طراح گرافیک" },
            { name: 'مترجم', image: require('@/assets/img/characters/translator.jpg'), id: 'translate', title: "مترجم" },
            { name: 'برنامه نویس', image: require('@/assets/img/characters/programmer.jpg'), id: 'code', title: "روبو برنامه نویس" },
            { name: 'کارشناس تولید محتوا', image: require('@/assets/img/characters/contentcreator.jpg'), id: 'karshenasmohtava', title: "کارشناس تولید محتوا" },
            { name: 'کارشناس رسانه های اجتماعی', image: require('@/assets/img/characters/socialmediaspecialist.jpg'), id: 'karsehnasresane', title: "کارشناس رسانه های اجتماعی" },
            { name: 'مدیر IT', image: require('@/assets/img/characters/itconsultant.jpg'), id: 'modirit', title: "مدیر IT" },
          ]
        },
        {
          id: 'khanande',
          name: 'خواننده ها',
          characters: [
            { name: 'جونگ کوک', image: require('@/assets/img/characters/jungkook.jpg'), id: 'jongkok', title: "جونگ کوک" },
            { name: 'مایکل جکسون', image: require('@/assets/img/characters/michaeljackson.jpg'), id: 'michaeljackson', title: "مایکل جکسون" },
            { name: 'تیلور سویفت', image: require('@/assets/img/characters/taylorswift.jpg'), id: 'taylorswift', title: "تیلور سویفت" },
            { name: 'سلنا گومز', image: require('@/assets/img/characters/selenagomez.jpg'), id: 'selenagomez', title: "سلنا گومز" },
          ]
        },
        {
          id: 'bazigaran',
          name: 'بازیگران و هنرمندان',
          characters: [
            { name: 'آنا د آرماس', image: require('@/assets/img/characters/anadearmas.jpg'), id: 'anadearmas', title: "آنا د آرماس" },
            { name: 'اسکارلت جوهانسون', image: require('@/assets/img/characters/scarlletjohansson.jpg'), id: 'scarletjohanson', title: "اسکارلت جوهانسون" },
            { name: 'هنری کویل', image: require('@/assets/img/characters/henrycavil.jpg'), id: 'henrycavil', title: "هنری کویل" },
            { name: 'لئوناردو دیکاپریو', image: require('@/assets/img/characters/dicaprio.jpg'), id: 'decaprio', title: "لئوناردو دیکاپریو" },
            { name: 'آلپاچینو', image: require('@/assets/img/characters/alpacino.jpg'), id: 'alpacino', title: "آلپاچینو" },
          ]
        },
        {
          id: 'movafaghiat',
          name: 'موفقیت',
          characters: [
            { name: 'ایلان ماسک', image: require('@/assets/img/characters/elonmusk.jpg'), id: 'elonmusk', title: "ایلان ماسک" },
            { name: 'رابرت کیوساکی', image: require('@/assets/img/characters/robertkiosaki.jpg'), id: 'robertkiosaki', title: "رابرت کیوساکی" },
            { name: 'وارن بافت', image: require('@/assets/img/characters/warenbofet.jpg'), id: 'warenboft', title: "وارن بافت" },
          ]
        },
        {
          id: 'tarikh',
          name: 'تاریخ',
          characters: [
            { name: 'حافظ شیرازی', image: require('@/assets/img/characters/hafezshirazi.jpg'), id: 'hafezshirazi', title: "حافظ شیرازی" },
            { name: 'آلبرت انیشتین', image: require('@/assets/img/characters/alberteinstein.jpg'), id: 'alberteinstein', title: "آلبرت انیشتین" },
            { name: 'فردوسی', image: require('@/assets/img/characters/ferdowsi.jpg'), id: 'ferdowsi', title: "فردوسی" },
            { name: 'نیکولا تسلا', image: require('@/assets/img/characters/nikolatesla.jpg'), id: 'nikolatesla', title: "نیکولا تسلا" },
            { name: 'گاندی', image: require('@/assets/img/characters/gandi.jpg'), id: 'gondi', title: "گاندی" },
          ]
        },
        {
          id: 'varzeshkaran',
          name: 'ورزشکاران و فوتبالیست ها',
          characters: [
            { name: 'کریستیانو رونالدو', image: require('@/assets/img/characters/ronaldo.jpg'), id: 'ronaldo', title: "کریستیانو رونالدو" },
            { name: 'لینول مسی', image: require('@/assets/img/characters/messi.jpg'), id: 'messi', title: "لیونل مسی" },
            { name: 'محمد علی کلی', image: require('@/assets/img/characters/keli.jpg'), id: 'keli', title: "محمد علی کلی" },
            { name: 'آرنولد', image: require('@/assets/img/characters/arnold.jpg'), id: 'arnold', title: "آرنولد" },
            { name: 'لبرون جیمز', image: require('@/assets/img/characters/lebronjames.jpg'), id: 'lebronjames', title: "لبرون جیمز" },
          ]
        },
        {
          id: 'oghatfaraghat',
          name: 'اوقات فراغت و سبک زندگی',
          characters: [
            { name: 'سرآشپز', image: require('@/assets/img/characters/chef.jpg'), id: 'sarashpaz', title: "سرآشپز" },
            { name: 'نویسنده', image: require('@/assets/img/characters/writer.jpg'), id: 'nevisande', title: "نویسنده" },
            { name: 'راهنمای تور', image: require('@/assets/img/characters/tourguide.jpg'), id: 'rahnamayetour', title: "راهنمای تور" },
          ]
        },
        {
          id: 'mahbobfilm',
          name: 'محبوب در فیلم ها',
          characters: [
            { name: 'جوکر', image: require('@/assets/img/characters/joker.jpg'), id: 'joker', title: "جوکر" },
            { name: 'هری پاتر', image: require('@/assets/img/characters/harrypotter.jpg'), id: 'harrypotter', title: "هری پاتر" },
            { name: 'بتمن', image: require('@/assets/img/characters/batman.jpg'), id: 'batman', title: "بتمن" },
            { name: 'تد', image: require('@/assets/img/characters/ted.jpg'), id: 'ted', title: "تد" },
            { name: 'والتر وایت', image: require('@/assets/img/characters/walterwhite.jpg'), id: 'walterwhite', title: "والتر وایت" },
            { name: 'مرد عنکبوتی', image: require('@/assets/img/characters/spiderman.jpg'), id: 'spiderman', title: "مرد عنکبوتی" },
          ]
        },
        {
          id: 'anime',
          name: 'انیمه',
          characters: [
            { name: 'لیوای اکرمن', image: require('@/assets/img/characters/levi.jpg'), id: 'leviackerman', title: "لیوای اکرمن" },
            { name: 'ارن یگر', image: require('@/assets/img/characters/eren.jpg'), id: 'erenyeager', title: "ارن یگر" },
            { name: 'ال', image: require('@/assets/img/characters/el.jpg'), id: 'el', title: "ال" },
            { name: 'گوجو ساتورو', image: require('@/assets/img/characters/kogo.jpg'), id: 'gojosatoro', title: "کوجو ساتورو" },
            { name: 'ریاس گریموری', image: require('@/assets/img/characters/rias.jpg'), id: 'ryasgerimori', title: "ریاس گریموری" },
          ]
        },
        {
          id: 'ertebatbamoshtari',
          name: 'ارتباط با مشتری و مدیریت',
          characters: [
            { name: 'متخصص امور مشتریان', image: require('@/assets/img/characters/customerservice.jpg'), id: 'motekhasesomormoshtarian', title: "متخصص امور مشتریان" },
            { name: 'برنامه ریز رویداد', image: require('@/assets/img/characters/eventplanner.jpg'), id: 'barnamerizroydad', title: "برنامه ریز رویداد" },
            { name: 'برنامه ریز عروسی', image: require('@/assets/img/characters/weddingplanner.jpg'), id: 'barnmaaroosi', title: "برنامه ریز عروسی" },
          ]
        },
        {
          id: 'kasbokar',
          name: 'کسب و کار و امور مالی',
          characters: [
            { name: 'بیزنس کوچ', image: require('@/assets/img/characters/businesscoach.jpg'), id: 'businesscouch', title: "بیزنس کوچ" },
            { name: 'کارشناس تجارت الکترونیک', image: require('@/assets/img/characters/ecommerce.jpg'), id: 'karshenastejarat', title: "کارشناس تجارت الکترونیک" },
            { name: 'کارشناس ایمیل مارکتینگ', image: require('@/assets/img/characters/emailmarketing.jpg'), id: 'karshenasemail', title: "کارشناس ایمیل مارکتینگ" },
            { name: 'کار آفرین', image: require('@/assets/img/characters/entrepreneur.jpg'), id: 'karafarin', title: "کار آفرین" },
            { name: 'کارشناس مالی', image: require('@/assets/img/characters/financial.jpg'), id: 'karshenasmali', title: "کارشناس مالی" },
            { name: 'کارشناس مارکتینگ', image: require('@/assets/img/characters/marketing.jpg'), id: 'karshenasmarketing', title: "کارشناس مارکتینگ" },
            { name: 'مدیر محصول', image: require('@/assets/img/characters/productmanager.jpg'), id: 'modirmahsoul', title: "مدیر محصول" },
          ]
        }
      ]
    };
  },
  computed: {
    displayCategories() {
      return this.filteredCategories.length > 0 ? this.filteredCategories : this.characterCategories;
    }
  },
  methods: {
    filterCharacters() {
      if (!this.searchQuery.trim()) {
        this.filteredCategories = [...this.characterCategories];
        return;
      }
      
      const query = this.searchQuery.toLowerCase().trim();
      this.filteredCategories = this.characterCategories.map(category => {
        const filteredCharacters = category.characters.filter(character => 
          character.name.toLowerCase().includes(query) ||
          character.title.toLowerCase().includes(query)
        );
        return {
          ...category,
          characters: filteredCharacters
        };
      }).filter(category => category.characters.length > 0);
    },
    clearSearch() {
      this.searchQuery = '';
      this.filteredCategories = [...this.characterCategories];
    },
    sendSuggestion() {
      if (this.chatbox != "") {
        let json = {
          token: localStorage.getItem("token"),
          comment: this.chatbox,
          subject: "characters"
        }
        axios.post("https://api.roboo.ir/api/Suggestion/AddSuggestion", json).then((response) => {
          if (response.data.status == 0) {
            this.chatbox = "";
            notify({
              title: "پیشنهادات",
              text: response.data.message,
              type: "success"
            });
          }
          else {
            notify({
              title: "خطا",
              text: response.data.message,
              type: "error"
            });
          }
        });
      }
      else {
        notify({
          title: "پیشنهادات",
          text: "متن پیشنهادی شما خالی است!",
          type: "error"
        });
      }
    },
    scrollToCategory(categoryId) {
      this.selectedCategory = categoryId;
      this.$nextTick(() => {
        const target = document.getElementById("category-" + categoryId);
        const container = this.$el.querySelector(".character-modal");

        if (target && container) {
          target.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      });
    }
  },
  mounted() {
    this.filteredCategories = [...this.characterCategories];
  }
};
</script>

<style scoped>
.scrollable-component {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  white-space: nowrap;
  padding: 10px 5px;
  min-height: 80px;
  align-items: center;
  scrollbar-width: none;
  position: sticky;
  top: -1px;
  background: #181818;
  z-index: 20;
}

.scrollable-component::-webkit-scrollbar {
  height: 6px;
}

.scrollable-component::-webkit-scrollbar-thumb {
  background: #6355cc;
  border-radius: 3px;
}

/* Modal Background */
.modal-bg {
  position: fixed;
  z-index: 100;
  top: 0; 
  left: 0; 
  right: 0; 
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
}

.character-modal {
  position: relative;
  background: #181818;
  border-radius: 16px;
  box-shadow: 0 8px 32px #000a;
  padding: 0 1.2rem 1.2rem 0.3rem;
  scroll-padding-top: 70px;
  width: 98vw;
  max-width: 420px;
  max-height: 98vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  animation: modalIn 0.3s ease-out;
}

@keyframes modalIn {
  from { 
    transform: scale(0.95) translateY(20px); 
    opacity: 0; 
  }
  to   { 
    transform: scale(1) translateY(0); 
    opacity: 1; 
  }
}

.close-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.7rem;
  background: #232323;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 2.2rem;
  height: 2.2rem;
  font-size: 1.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: background 0.2s;
  box-shadow: 0 2px 8px #0003;
}

.close-btn:hover, .close-btn:focus {
  background: #fd7691;
  color: #fff;
}

.modal-title {
  color: #9184f7;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0.7rem;
  font-size: 1.1rem;
  margin-top: 0.7rem;
}

/* Search Section Styles */
.search-section {
  margin-bottom: 1.5rem;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  right: 12px;
  color: #888;
  font-size: 14px;
  z-index: 1;
}

.search-input {
  width: 100%;
  padding: 12px 40px 12px 12px;
  background-color: #232323;
  border: 1px solid #444;
  border-radius: 8px;
  color: white;
  font-family: IRANSansWeb, sans-serif;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

.search-input:focus {
  border-color: #6355cc;
}

.search-input::placeholder {
  color: #888;
}

.clear-search-btn {
  position: absolute;
  left: 8px;
  background: none;
  border: none;
  color: #888;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.2s;
}

.clear-search-btn:hover {
  color: #fd7691;
}

.category-button {
  display: inline-block;
  color: #6355cc;
  font-weight: bold;
  font-size: 0.9rem;
  border: 1px solid #6355cc;
  border-radius: 20px;
  padding: 8px 16px;
  white-space: nowrap;
  box-sizing: border-box;
  background: transparent;
  transition: all 0.2s;
}

.category-button.active {
  background: #6355cc;
  color: #fff;
}

.category-group {
  margin-bottom: 1.5rem;
}

.category-title {
  color: #6355cc;
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.5rem;
  border-right: 4px solid #6355cc;
  padding-right: 0.5rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.character-count {
  color: #888;
  font-size: 0.9rem;
  font-weight: normal;
}

.character-list {
  display: flex;
  gap: 15px;
  overflow-x: auto;
  padding: 10px 0;
  scrollbar-width: none;
}

.character-list::-webkit-scrollbar {
  display: none;
}

.character-card {
  flex: 0 0 auto;
  width: 150px;
  background-color: #303030;
  border-radius: 10px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.character-card:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 8px 20px rgba(97, 83, 204, 0.3);
}

.character-card:active {
  transform: translateY(-2px) scale(0.98);
}

.character-image {
  height: 120px;
  background-color: #6153cc;
  background-size: cover;
  background-position: center;
}

.character-info {
  padding: 8px;
  text-align: center;
}

.character-name {
  color: white;
  font-size: 14px;
  font-weight: bold;
  display: block;
  margin-bottom: 8px;
  line-height: 1.2;
  max-height: 2.4em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.chat-button {
  background-color: #6153cc;
  padding: 6px 12px;
  border-radius: 15px;
  color: white;
  font-family: IRANSansWeb, sans-serif;
  font-weight: bold;
  font-size: 12px;
}

/* No Results Message */
.no-results {
  text-align: center;
  padding: 3rem 1rem;
  color: #888;
}

.no-results i {
  font-size: 3rem;
  color: #6355cc;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.no-results p {
  font-size: 1.1rem;
  margin-bottom: 1rem;
  color: #aaa;
}

.clear-search-link {
  background: none;
  border: none;
  color: #6355cc;
  cursor: pointer;
  font-size: 1rem;
  text-decoration: underline;
  transition: color 0.2s;
}

.clear-search-link:hover {
  color: #fd7691;
}

/* Desktop styles */
@media (min-width: 600px) {
  .character-modal {
    max-width: 600px;
    padding: 2rem 2rem 1.5rem 2rem;
  }
  
  .modal-title {
    font-size: 1.3rem;
  }
  
  .category-title {
    font-size: 1.1rem;
  }
  
  .character-card {
    width: 180px;
  }
  
  .character-image {
    height: 150px;
  }
  
  .character-name {
    font-size: 16px;
  }
  
  .chat-button {
    font-size: 14px;
    padding: 8px 16px;
  }
}

/* Suggestion Box Styles */
.suggestion-section {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #333;
}

.suggestion-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 1rem;
}

.suggestion-title i {
  color: #6355cc;
  font-size: 1.2rem;
}

.suggestion-title span {
  color: #9184f7;
  font-weight: bold;
  font-size: 1.1rem;
}

.suggestion-textarea {
  margin-bottom: 1rem;
}

.suggestion-input {
  width: 100%;
  min-height: 100px;
  padding: 12px;
  background-color: #232323;
  border: 1px solid #444;
  border-radius: 8px;
  color: white;
  font-family: IRANSansWeb, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  outline: none;
  transition: border-color 0.2s;
}

.suggestion-input:focus {
  border-color: #6355cc;
}

.suggestion-input::placeholder {
  color: #888;
}

.suggestion-button {
  background-color: #6153cc;
  padding: 12px 20px;
  text-align: center;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background-color 0.2s;
  margin: 0 auto;
  width: fit-content;
}

.suggestion-button:hover {
  background-color: #5a4bb8;
}

.suggestion-button span {
  color: white;
  font-weight: bold;
  font-family: IRANSansWeb, sans-serif;
  font-size: 16px;
}

.suggestion-button i {
  color: white;
  font-size: 16px;
}

/* Font face for Persian text */
@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWeb.woff2') format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: IRANSansWeb;
  src: url('../assets/IRANSansWebBold.woff2') format("woff2");
  font-weight: bold;
  font-style: normal;
}
</style>
